import {createSlice} from "@reduxjs/toolkit";

const initialBankAccountState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  bankAccountForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const bankAccountSlice = createSlice({
  name: "bankAccount",
  initialState: initialBankAccountState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getProductById
    bankAccountFetched: (state, action) => {
      state.actionsLoading = false;
      state.bankAccountForEdit = action.payload.bankAccountForEdit;
      state.error = null;
    },
    // findBankAccount
    bankAccountListFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createProduct
    bankAccountCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.bankAccount);
    },
    // updateProduct
    bankAccountUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.bankAccount.id) {
          return action.payload.bankAccount;
        }
        return entity;
      });
    },
    // deleteProduct
    bankAccountDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteBankAccount
    bankAccountDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // bankAccountUpdateState
    bankAccountStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
